import { Typography } from '@material-ui/core';
import { LightToolTip } from './CustomToolTip';
import { useStyles } from '../theme';
import { useIsFeatureFlagEnabled } from '../contexts/feature-flag-context';

import styled from '@emotion/styled';
import titleize from 'titleize';
import Moment from 'react-moment';
import Brightness1Icon from '@material-ui/icons/Brightness1';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import { SENDER_ICON, UPS_ICON, XD_ICON } from '../constants';

const styles = (theme) => ({
  priorityIcon: {
    fontSize: 28
  },
  critical: {
   color: '#E34025'
  },
  high: {
    color: '#FDB913'
  },
  medium: {
    color: '#EAD417'
  },
  low: {
    color: '#72BF44'
  },
});


const TitleWrapper = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  margin-bottom: 20px;
  gap: 8px;
`;

const TitleLabel = styled(Typography)`
  font-size: 26px;
  line-height: 32px;
`;

const nameIconMap = {
  MI: {
    icon: UPS_ICON,
    alt: "UPS Icon"
  },
  S: {
    icon: SENDER_ICON,
    alt: "Sender Icon"
  },
  XD: {
    icon: XD_ICON,
    alt: "Crossdock Icon"
  }
};

const LabelText = ({ classes, name, priority, rule }) => {

  if (priority) {
    return (
      <>
        <Brightness1Icon className={`${classes.priorityIcon} ${classes[priority]}`}/>
        <TitleLabel>{ titleize(priority) } {rule && ( <> -  {titleize(rule)} </>)}</TitleLabel>
      </>
    );
  } else if (name) {
    const identifier = name.split("-")[0].trim().toUpperCase();
    const nameIcon = nameIconMap[identifier];

    return (
      <>
        {nameIcon && <img
            src={nameIcon.icon}
            alt={nameIcon.alt}
            height="22px"
            style={{ verticalAlign: 'text-top', marginRight: 5 }}
          />}
        <TitleLabel> {name} </TitleLabel>
      </>
    );
  }
}

  const tooltipInfoText = (
    <span>
      This shows when the data was last synced.<br/> A red dot appears if it's older than 30 minutes.
    </span>
  )

export const Title = ({ timestamp, priority, name, rule }) => {
  const classes = useStyles(styles);
  const titleFlag = useIsFeatureFlagEnabled("vip-fe-priority-buckets-headers");
  const timestampFlag = useIsFeatureFlagEnabled("vip-fe-add-last-updated");

  const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const isEasternTimezone = userTimeZone === 'America/New_York';

  const timestampDate = new Date(timestamp);
  const now = new Date(); 
  const thirtyMinutesInMs = 30 * 60 * 1000
  const longerThanTimeLimit = now - timestampDate > thirtyMinutesInMs


  return (
    <TitleWrapper>
      {titleFlag && <LabelText
        classes={classes}
        priority={priority}
        name={name}
        rule={rule}
      />}
      { timestamp && timestampFlag &&
        <span style={{ marginLeft: "auto" }} >
          {longerThanTimeLimit && 
            <Brightness1Icon style={{ fontSize: 6, verticalAlign: "text-top", color: "red", marginRight: 5 }} />
          }
          <Typography variant="body2" component="span">
            Last Sync 
            <LightToolTip placement="top" title={tooltipInfoText} maxWidth="300px" arrow>
              <HelpOutlineIcon style={{ fontSize: 20, verticalAlign: "sub", marginLeft: '6px', marginRight: '8px' }} />
            </LightToolTip>
            </Typography>
            <Typography variant="body2" component="div" style={{ color: "#4C4C4C", display: 'inline-table'}}>
            <Moment date={timestamp} format="MM/DD/Y, hh:mm A z" tz='America/New_York'></Moment>
            {!isEasternTimezone && 
              <>
                <br/>
                <Moment style={{ color: "#7A7A7A" }} date={timestamp} format="MM/DD/Y, hh:mm A z" tz={userTimeZone}></Moment>
              </>
            }
            </Typography>
        </span>
      }
    </TitleWrapper>
  );
};
